import { baseApi } from '@/shared/api/base-api';
import { normalizePro20Response } from '@/shared/api/pro20-transform';

import type { LegacyCreditCardDetails } from '../types/legacy-card.types';

async function readPaymentResponse(response: Response): Promise<unknown> {
  const text = await response.text();
  if (!text.trim()) {
    return null;
  }
  return JSON.parse(text) as unknown;
}

export const legacyCardApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    validateLegacyCreditCard: builder.mutation<
      unknown,
      LegacyCreditCardDetails
    >({
      query: (body) => ({
        url: '/payment/validate',
        method: 'POST',
        body,
        responseHandler: readPaymentResponse,
      }),
      transformResponse: (response: unknown) =>
        normalizePro20Response(response ?? null),
    }),
    storeLegacyCreditCard: builder.mutation<unknown, LegacyCreditCardDetails>({
      query: (body) => ({
        url: '/payment/store',
        method: 'POST',
        body,
        responseHandler: readPaymentResponse,
      }),
      transformResponse: (response: unknown) =>
        normalizePro20Response(response ?? null),
    }),
  }),
});

export const {
  useValidateLegacyCreditCardMutation,
  useStoreLegacyCreditCardMutation,
} = legacyCardApi;
